import styled, { css } from 'styled-components';

export const LogoContainer = styled.div(
  ({ theme }) => css`
    width: ${theme.sz.s10};
    height: ${theme.sz.s10};
    background-color: ${theme.co.secondary20};
    border-radius: ${theme.bo.round};

    svg {
      width: 100%;
      height: 100%;
      padding: ${theme.sz.s2};
    }
  `,
);

export const MemriseTeamBanner = styled.div(
  ({ theme }) => css`
    width: fit-content;
    padding: ${theme.sz.s3} ${theme.sz.s5};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: ${theme.sz.s2};
    background: ${theme.co.primary20};
    border-radius: ${theme.bo.small};
    color: ${theme.co.secondary0};
    ${theme.typography.heading.mobile.xxs};

    @media (min-width: ${theme.sz.md}) {
      padding: ${theme.sz.s3} ${theme.sz.s6};
      ${theme.typography.heading.desktop.xxs};
    }
  `,
);
